export default "__VITE_ASSET__D8a8xwu8__"